<div
  *ngIf="turnstileService.getSiteKey() && ((turnstileService.shouldRender$ | async) || instanceRenderedOnce)"
  #turnstileContainer
  class="turnstile-container"
></div>
